import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { HomeResponse } from '../../responses/platform/search-autocomplete.response copy';

@Injectable({
  providedIn: 'root',
})
export class HomeService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(): Observable<HomeResponse> {
    return this.httpClient
      .get<HomeResponse>(environment.urlApiPlatform + 'Home')
      .pipe(catchError(this.handleError));
  }
}
